<div class="grid grid-cols-5 gap-y-4">
	<div class="flex flex-1 gap-4 col-start-1 col-span-2 mb-4 mt-2">
		<p>Parcel Description</p>
		<div class="w-24">
			<img src="/assets/images/teranet-logo.jpg" />
		</div>
	</div>

	<div class="flex justify-center mt-2">
		<p>Add to Matter</p>
	</div>

	<div class="col-start-4 mb-4 mt-2" [class.hidden]="!_showComparison">
		Customize Parcel
	</div>

	<div
		class="col-start-5 flex justify-end h-8"
		*ngIf="matchingTitle && _showComparison"
	>
		<div
			class="w-auto flex items-center justify-center rounded-xl p-1 px-2 border border-green-200 text-green-600 bg-tealGreen-50 text-sm"
		>
			<app-icon [icon]="ICON.CHECK" class="mr-2"></app-icon>
			Synced
		</div>
	</div>

	<app-select
		*ngIf="isCondoUnit"
		name="unitType"
		label="Unit type"
		[(ngModel)]="$any(title).unitType"
		(ngModelChange)="updateTitle()"
		class="col-start-4 pl-3"
		[class.hidden]="!_showComparison"
		[testHook]="testHooks.UnitTypeSelect"
	>
		<option *ngFor="let unitType of unitTypes" [testHook]="testHooks.Option">
			{{ unitType }}
		</option>
	</app-select>

	<div
		class="flex flex-col gap-4 col-start-1 col-span-2 row-span-3 bg-grey-lightest rounded-lg border border-grey-veryLight p-6"
	>
		<div class="w-24">
			<img src="/assets/images/teranet-logo.jpg" />
		</div>
		<div>
			<p class="text-grey mb-2">PIN</p>
			{{ originalPin.pin }}
		</div>
		<div>
			<p class="text-grey mb-2">Description</p>
			{{ originalPin.legal_desc }}
		</div>

		<div>
			<p class="text-grey mb-2">Latest Instrument</p>
			{{ latestInstrument }}
		</div>
	</div>

	<div class="flex justify-center items-start w-full col-start-3">
		<app-input-wrapper
			class="flex justify-center items-center"
			[testHook]="testHooks.InputWrapper"
		>
			<atomic-switch
				[ngModel]="_showComparison"
				(click)="toggleSync($event)"
				[testHook]="testHooks.ShowComparisonSwitch"
			></atomic-switch>
		</app-input-wrapper>
	</div>

	<div
		class="col-start-4 col-span-2 border-l border-grey-lighter pl-3"
		[class.hidden]="!_showComparison"
	>
		<app-input
			class=""
			label="PIN"
			[(ngModel)]="$any(title).pinNumber"
			(onBlur)="updateTitle()"
			disabled
			[testHook]="testHooks.Pin"
		></app-input>
	</div>

	<div
		class="grid grid-cols-2 col-start-4 col-span-2 gap-1 border-l border-grey-lighter pl-3"
		[class.hidden]="!_showComparison"
	>
		<app-text-area
			class="col-span-2"
			label="Description"
			[(ngModel)]="$any(title).legalDescription"
			(onBlur)="updateTitle()"
			[testHook]="testHooks.DescriptionTextArea"
		></app-text-area>
		<app-input
			*ngIf="!isCondoUnit"
			class="col-start-1"
			label="Lot"
			[(ngModel)]="$any(title).lot"
			(onBlur)="updateTitle()"
			[testHook]="testHooks.Lot"
		></app-input>

		<app-input
			*ngIf="isCondoUnit"
			label="Unit no."
			[(ngModel)]="$any(title).unitNumber"
			(onBlur)="updateTitle()"
			[testHook]="testHooks.UnitNo"
		></app-input>
		<app-input
			*ngIf="isCondoUnit"
			label="Level no."
			[(ngModel)]="$any(title).levelNumber"
			(onBlur)="updateTitle()"
			[testHook]="testHooks.LevelNo"
		></app-input>
		<app-input
			label="Plan"
			[class.col-span-2]="isCondoUnit"
			[(ngModel)]="$any(title).planName"
			(onBlur)="updateTitle()"
			[testHook]="testHooks.Plan"
		></app-input>
	</div>

	<div
		class="border-l border-grey-lighter pl-3 col-start-4 col-span-2"
		[class.hidden]="!_showComparison"
	>
		<app-input
			class=""
			label="Latest Instrument"
			[(ngModel)]="$any(title).latestInstrument"
			(onBlur)="updateTitle()"
			[testHook]="testHooks.LatestInstrument"
		></app-input>
	</div>
</div>
